"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaKekkaSokatsu = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 総括
 */
const PreLineTypography = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.body2.fontSize
  };
});
const KansaKekkaSokatsu = props => {
  const {
    intl,
    sokatsu
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_SOKATSU
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(sokatsu)));
};
exports.KansaKekkaSokatsu = KansaKekkaSokatsu;
var _default = exports.default = (0, _reactIntl.injectIntl)(KansaKekkaSokatsu);